export default __webpack_public_path__ + "static/media/emoji-stats.aee84103.svg";